<template>
  <div class="lot-data">
    <div class="row">
      <div class="col-lg-4 mb-6">
        <bp-input
          v-model="lot.name"
          required
          ref="inputName"
          label="Nome do ingresso"
          placeholder="Ex: Ingresso 01"
          description="Este nome será exibido apenas para você, em sua tabela de lotes."
        />
      </div>
      <div class="col-lg-4 mb-6">
        <bp-input
          v-model="lot.stock"
          number
          required
          ref="inputStock"
          label="Quantidade de ingressos"
          placeholder="00"
          description="Quantos ingressos estarão disponíveis para venda."
        />
      </div>
      <div class="col-lg-4 mb-6">
        <bp-input
          v-model="lot.price"
          money
          required
          ref="inputPrice"
          placeholder="R$ 0,00"
          label="Valor"
          description="Defina quanto custará o seu evento. Certifique-se de que o valor não seja menor que R$4,00."
          :min="4"
        />
      </div>
    </div>

    <bp-radio
      v-model="lot.type"
      class="mb-6"
      :disabled="!parentOptions.length"
      :options="[
        { id: 'by_date', name: 'Por data' },
        {
          id: 'per_batch',
          name: 'Por lote',
          warning:
            'Ingressos por lote deverão estar atrelados ao final da venda de um lote predefinido. Sendo assim, configure seu primeiro ingresso antes de selecionar essa opção.'
        }
      ]"
    />

    <div class="row">
      <div class="col-lg-6 mb-6 mb-lg-0">
        <bp-select
          v-if="lot.type == 'per_batch'"
          v-model="lot.parent_id"
          required
          class="pt-3"
          description="Escolha o tipo de ingresso"
          label="Início das vendas quando esse ingresso esgotar"
          :options="parentOptions"
        />

        <form-group
          v-else
          v-model="lot.start_at"
          is-date
          readonly
          required
          mode="dateTime"
          id="start-date"
          with-clear-button
          label="Data de início das vendas"
          placeholder="Selecione a data inicial"
          :min-date="new Date()"
        />
      </div>
      <div class="col-lg-6">
        <form-group
          v-model="lot.end_at"
          is-date
          readonly
          required
          mode="dateTime"
          id="start-date"
          with-clear-button
          label="Data de término das vendas"
          placeholder="Selecione a data final"
          :min-date="minEndDate"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { toComputerDate } from "@/functions/helpers";
export default {
  props: {
    lot: {
      type: Object,
      default: () => ({})
    },
    parentOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    minEndDate() {
      if (this.lot.start_at) return new Date(toComputerDate(this.lot.start_at));

      return new Date();
    }
  },
  methods: {
    resetInputs() {
      Object.values(this.$refs).forEach(ref => ref.reset && ref.reset());
    }
  },
  watch: {
    "lot.start_at"(v) {
      if (
        (!v && this.lot.end_at) ||
        (this.lot.end_at &&
          new Date(toComputerDate(v)) >
            new Date(toComputerDate(this.lot.end_at)))
      ) {
        this.$emit("reset-end-date");
      }
    },
    parentOptions(v) {
      if (!v.length) this.lot.type = "by_date";
    }
  }
};
</script>
